import img01 from "../../images/chapters/06/moons/01.jpg";
import img02 from "../../images/chapters/06/moons/02.jpg";
import img03 from "../../images/chapters/06/moons/03.jpg";
import img04 from "../../images/chapters/06/moons/04.jpg";
import img05 from "../../images/chapters/06/moons/05.jpg";
import img06 from "../../images/chapters/06/moons/06.jpg";
import img07 from "../../images/chapters/06/moons/07.jpg";
import img08 from "../../images/chapters/06/moons/08.jpg";
import img09 from "../../images/chapters/06/moons/09.jpg";
import img10 from "../../images/chapters/06/moons/10.jpg";
import img11 from "../../images/chapters/06/moons/11.jpg";
import img12 from "../../images/chapters/06/moons/12.jpg";
import img13 from "../../images/chapters/06/moons/13.jpg";
import img14 from "../../images/chapters/06/moons/14.jpg";
import img15 from "../../images/chapters/06/moons/15.jpg";
import img16 from "../../images/chapters/06/moons/16.jpg";
import img17 from "../../images/chapters/06/moons/17.jpg";
import img18 from "../../images/chapters/06/moons/18.jpg";
import img19 from "../../images/chapters/06/moons/19.jpg";
import img20 from "../../images/chapters/06/moons/20.jpg";
import img21 from "../../images/chapters/06/moons/21.jpg";
import img22 from "../../images/chapters/06/moons/22.jpg";
import img23 from "../../images/chapters/06/moons/23.jpg";
import img24 from "../../images/chapters/06/moons/24.jpg";
import img25 from "../../images/chapters/06/moons/25.jpg";
import img26 from "../../images/chapters/06/moons/26.jpg";
import img27 from "../../images/chapters/06/moons/27.jpg";
import img28 from "../../images/chapters/06/moons/28.jpg";
import img29 from "../../images/chapters/06/moons/29.jpg";
import img30 from "../../images/chapters/06/moons/30.jpg";

export const captions = [
  "View of the Instrument panel inside the Lunar Module.",
  "Astronaut Neil. Armstrong, Apollo 11 Commander, insidethe Lunar Module as it rest on the lunar surface after competion of the Extravehicular Activities (EVA).",
  "Buzz Aldrin works inside the Lunar Module during checkout and inspection after hatch opening.",
  "Mike Collins sitting in the Command and Service Module.",
  "View of Moon, Muller Target of Opportunity (TO) 137.\nTO 137 is possible Volcanic features associated with typical, large, \nold highland craters.\nThis image was taken from the Command and Service Module.",
  "View of Moon, Horrocks and Hipparchus Target of Opportunity (TO) 137. TO 137 is possible Volcanic features\nassociated with typical, large, old highland craters. This image was taken from the Command and Service Module.",
  "View of Moon, Hipparchus F Target of Opportunity (TO) 137.\nTO 137is possible volcanic features associated with typical, large, old highland craters.\nThis image was taken from the Command and Service Module.",
  "View of Moon, no identifiable features. This image was taken from the Command and Service Module as it traveled around the backside of the Moon.",
  "View of Moon, Hipparchus F Target of Opportunity (TO) 137.\nTO 137is possible volcanic features associated with typical, large, old highland craters.\nThis image was taken from the Command and Service Module.",
];

export const moonImgs = [
  img01,
  img02,
  img03,
  img04,
  img05,
  img06,
  img07,
  img08,
  img09,
  img10,
  img11,
  img12,
  img13,
  img14,
  img15,
  img16,
  img17,
  img18,
  img19,
  img20,
  img21,
  img22,
  img23,
  img24,
  img25,
  img26,
  img27,
  img28,
  img29,
  img30,
];
